import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchUser, updateUser, addUser } from '../actions/users'
import { renderInputField, renderSelectField } from '../utils/forms'

class UserEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false, isEditing: false }
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { editingUser, match, fetchUser } = this.props

    if (editingUser) {
      // Modal mode: user data passed as prop
      this.setState({ loaded: true, isEditing: true })
    } else if (match && match.params && match.params.id) {
      // Route mode: fetch by URL param
      this.setState({ isEditing: true })
      fetchUser(match.params.id)
    } else {
      // New user mode
      this.setState({ loaded: true, isEditing: false })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match && this.props.match &&
        prevProps.match.params.id !== this.props.match.params.id) {
      this.setState({ loaded: false })
      this.props.fetchUser(this.props.match.params.id)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.users.user) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { updateUser, addUser, editingUser, onSubmit, match } = this.props
    const { isEditing } = this.state

    const userId = editingUser ? editingUser._id : (match && match.params && match.params.id)

    const action = isEditing
      ? updateUser(userId, props)
      : addUser(props)

    return action.then(response => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields
        })
      }
      if (onSubmit) {
        onSubmit()
      } else {
        this.props.push(`/users/${response.response._id}`)
      }
      return response
    })
  }

  render() {
    const { users, error, pristine, submitting, handleSubmit, auth, editingUser, onCancel } = this.props
    const { loaded, isEditing } = this.state

    if (!loaded) {
      if (users.error) {
        return <ErrorMessage message={users.error.message} />
      }
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className="row">
          <div className="col">
            <Box title="Datos personales" icon="user">
              <Field name="fullname" type="text" component={renderInputField} label="Nombre" />
              <Field name="shiftcode" type="number" component={renderInputField} label="Código Fichaje" />
              <Field name="workingday" type="number" component={renderInputField} label="Jornada" />
              <Field name="rest" component={renderSelectField} label="Descanso">
                <option value="">Selecciona un descanso...</option>
                <option value="0">Ninguno</option>
                <option value="30">30 min</option>
                <option value="60">1 hora</option>
              </Field>
            </Box>
          </div>
          <div className="col">
            <Box title="Plantilla" icon="user">
              <Field name="active" component={renderSelectField} label="Usuario activo">
                <option value="">¿El usuario forma parte de la plantilla actual?</option>
                <option value="false">No</option>
                <option value="true">Si</option>
              </Field>
            </Box>
            <Box title="Acceso" icon="user">
              <Field name="email" type="text" component={renderInputField} label="E-mail" />
              <Field name="password" type="password" component={renderInputField} label="Password" />
            </Box>
          </div>
          {auth.type === 'GOD' && (
            <div className="col">
              <Box title="Plataforma" icon="user">
                <Field name="type" component={renderSelectField} label="Tipo">
                  <option value="">Selecciona un tipo...</option>
                  <option value="GOD">Administrador</option>
                  <option value="ROOT">Root</option>
                  <option value="HHRR">Recursos Humanos</option>
                  <option value="CASH">Contabilidad</option>
                  <option value="LIMITED">Trabajador</option>
                </Field>
                <Field name="notifications" type="text" component={renderInputField} label="E-mail de notificaciones" />
              </Box>
            </div>
          )}
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="d-flex justify-content-between">
          {onCancel && (
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={submitting}>
              Cancelar
            </button>
          )}
          <button className="btn text-white bg-vw-light mr-1 save ml-auto" type="submit" disabled={pristine || submitting}>
            {submitting ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    )
  }
}

const UserEditFormWrapped = reduxForm({
  form: 'UserEditForm',
  enableReinitialize: true,
})(UserEditForm)

const mapStateToProps = (state, ownProps) => ({
  users: state.users,
  auth: state.auth,
  initialValues: ownProps.editingUser
    ? {
        fullname: ownProps.editingUser.fullname || '',
        email: ownProps.editingUser.email || '',
        password: '',
        type: ownProps.editingUser.type || '',
        shiftcode: ownProps.editingUser.shiftcode || '',
        workingday: ownProps.editingUser.workingday || 40,
        rest: ownProps.editingUser.rest || 60,
        active: ownProps.editingUser.active !== undefined ? String(ownProps.editingUser.active) : 'true',
        notifications: ownProps.editingUser.notifications || '',
      }
    : state.users.user,
})

const mapDispatchToProps = dispatch => ({
  fetchUser: bindActionCreators(fetchUser, dispatch),
  updateUser: bindActionCreators(updateUser, dispatch),
  addUser: bindActionCreators(addUser, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(UserEditFormWrapped)

